import { render, staticRenderFns } from "./usergroup-vehicle-offline-analysis-results.vue?vue&type=template&id=2b285ebb&scoped=true"
import script from "./usergroup-vehicle-offline-analysis-results.vue?vue&type=script&lang=js"
export * from "./usergroup-vehicle-offline-analysis-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b285ebb",
  null
  
)

export default component.exports